import { z } from 'zod';
import { FirestoreTimestamp } from './common.schema.js';
import { SubscriptionSchema } from './billing.schema.js';
// --- Schemas ---
export const UserProjectSchema = z.object({
    projectId: z.string().uuid(),
    name: z.string(),
    tenantId: z.string(),
    assets: z.array(z.object({
        imageId: z.string(),
        url: z.string(),
        prompt: z.string().optional()
    })).optional(),
    is_favorite: z.boolean().default(false),
    created_at: FirestoreTimestamp,
    updated_at: FirestoreTimestamp.optional()
});
export const UserGlobalPreferencesSchema = z.object({
    theme: z.enum(['light', 'dark', 'auto']).default('auto'),
    notifications: z.boolean().default(true),
    language: z.string().default('en')
});
export const UserSchema = z.object({
    uid: z.string(),
    email: z.string().email().nullable().optional(),
    displayName: z.string().optional(),
    photoURL: z.string().url().or(z.literal('')).nullable().optional(),
    home_tenant: z.string().optional(),
    // Read-only mirror of tenant memberships for fast access
    tenants: z.record(z.string(), z.object({
        role: z.enum(['admin', 'editor', 'viewer', 'guest', 'member']),
        joinedAt: FirestoreTimestamp
    })).optional(),
    billing: SubscriptionSchema.optional(), // Can be null if free/uninitialized
    global_preferences: UserGlobalPreferencesSchema.optional(),
    created_at: FirestoreTimestamp,
    last_login: FirestoreTimestamp.optional(),
    version: z.number().default(2)
});
